import { Route, Switch } from 'react-router-dom';
import { Billing } from '../containers/Billing';
import { Payments } from '../containers/Payments';
import { ViewInvoice } from '../containers/ViewInvoice';
import { UpdatePaymentMethod } from '../containers/UpdatePaymentMethod';
import { TabContainer } from '../containers/TabContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ROUTES = {
  billing: '/',
  payments: '/payments',
  invoice: '/invoice',
  updatePaymentMethod: '/update-payment-method'
};
export function Routes() {
  return /*#__PURE__*/_jsxs(Switch, {
    children: [/*#__PURE__*/_jsx(Route, {
      path: ROUTES.invoice,
      exact: true,
      component: ViewInvoice
    }), /*#__PURE__*/_jsx(Route, {
      path: ROUTES.updatePaymentMethod,
      exact: true,
      component: UpdatePaymentMethod
    }), /*#__PURE__*/_jsxs(TabContainer, {
      children: [/*#__PURE__*/_jsx(Route, {
        path: ROUTES.payments,
        exact: true,
        component: Payments
      }), /*#__PURE__*/_jsx(Route, {
        path: ROUTES.billing,
        exact: true,
        component: Billing
      })]
    })]
  });
}